import * as React from "react";

const CheckmarkCircle = (): JSX.Element => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
            fill="#007B22"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.2804 16.4636C34.1289 17.1707 34.2436 18.4319 33.5364 19.2804L23.5364 31.2804C23.1767 31.7121 22.652 31.9725 22.0906 31.998C21.5293 32.0235 20.9831 31.8116 20.5858 31.4143L14.5858 25.4143C13.8047 24.6332 13.8047 23.3669 14.5858 22.5858C15.3668 21.8048 16.6332 21.8048 17.4142 22.5858L21.8656 27.0372L30.4636 16.7197C31.1707 15.8711 32.4318 15.7565 33.2804 16.4636Z"
            fill="white"
        />
    </svg>
);

export default CheckmarkCircle;
